<div class="subscription-control" [class.subscription-control--toggle]="isToggleVariant">
	<ion-checkbox *ngIf="!isToggleVariant" [formControl]="formControl" mode="ios" (ionChange)="handleControlChange($event)"></ion-checkbox>
	<p
		class="subscription-copy ion-text-wrap"
		role="region"
		aria-label="Privacy section"
		[innerHTML]="'subscribe_to_mailing.text' | translate"
	></p>
	<ion-toggle *ngIf="isToggleVariant" [formControl]="formControl" mode="ios" (ionChange)="handleControlChange($event)"></ion-toggle>
</div>
